<template>
  <f7-page>
    <div class="text-center">
      <div class="sm:flex justify-center">
        <img
          class="m-5"
          src="@/assets/populations.svg"
          alt="Poblaciones"
        >
        <div
          class="text-4xl font-bold text-center sm:my-20"
        >
          Poblaciones
        </div>
      </div>
    </div>
    <population-crud />
  </f7-page>
</template>
<script>
import { mapState } from 'vuex'
import PopulationCrud from '@/components/populationCrud'

export default {
  name: 'Template',
  components: {
    PopulationCrud,
  },
  data () {
    return {
      tagInput: null,
      inputValue: '',
      currentTags: [],
      tags: ['estudiantes', 'profesores', 'bachillerato', 'primaria'],
    }
  },
  computed: {
    filteredTags () {
      if (this.selectedTag) {
        return this.tags.filter(tag => {
          return tag === this.selectedTag
        })
      }
      if (!this.inputValue) {
        return this.tags
      } else {
        return this.tags.filter(tag => {
          return tag.includes(this.inputValue)
        })
      }
    },
    ...mapState({
    }),
  },
  watch: {
    inputValue: function () {
      if (this.inputValue.includes(',')) {
        const tags = this.inputValue.split(',').map(tag => {
          return tag.trim()
        })
        for (const tag of tags) {
          // eslint-disable-next-line no-extra-boolean-cast
          if (!!tag) {
            this.addTag(tag, false)
          }
        }
      }
    },
  },
  async mounted () {
    this.tagInput = document.getElementById('tag-input')
    this.tagInput.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        this.addTag(this.inputValue)
      }
      if (event.keyCode === 9) {
        this.addTag(this.inputValue)
      }
    })
    this.tagInput.addEventListener('keydown', (event) => {
      if (event.keyCode === 9) {
        event.preventDefault()
      }
    })
  },
  methods: {
    addTag (tag, approximate = true) {
      if (this.filteredTags[0] && approximate) {
        tag = this.filteredTags[0]
      }
      if (this.tags.indexOf(tag) === -1) {
        // TODO: show error
        return
      }
      if (tag) {
        if (this.currentTags.indexOf(tag) === -1) {
          this.currentTags.push(tag)
        }
        this.inputValue = ''
      }
    },
    removeTag (tag) {
      this.currentTags.splice(this.currentTags.indexOf(tag), 1)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
